














import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FilterButton extends Vue {
    @Prop({ default: 'Label' }) label: string;
    @Prop({ default: false }) activeButton: boolean;
    @Prop({ default: false }) disabled: boolean;

    get color(): string {
        return this.activeButton ? 'green' : '';
    }

    @Emit()
    clickFilterButton() {}
}
